import { EditableType } from '../../../containers/Editor/constants';
import { EnrichmentType } from '../../../containers/Editor/utils/indesignEditor/constants';

export enum AdditionalPanelType {
	settings = 'settings',
}

export type PanelType = EditableType | EnrichmentType | AdditionalPanelType;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/constants.ts